  import React, { useEffect, useState } from "react";
  import Carousel from "react-multi-carousel";
  import "react-multi-carousel/lib/styles.css";
  import { testimonialApi, BASE_URL, FILE_URL } from "../../API/Api";

  const HappyClients = () => {
    const [clients, setClients] = useState([]);

    useEffect(() => {
      const fetchTestimonials = async () => {
        try {
          const data = await testimonialApi.getTestimonials();
          setClients(data);
        } catch (error) {
          console.error("Error fetching testimonials:", error);
        }
      };
      fetchTestimonials();
    }, []);

    const responsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 2 },
      tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
    };

    return (
      <section className="slide-profile">
        <h2 className="text-center mb-4">Our Happy Clients</h2>
        <div className="container">
          {clients.length > 0 && (
            <Carousel
              responsive={responsive}
              infinite
              autoPlay
              autoPlaySpeed={6000}
              arrows
              keyBoardControl
              showDots={false}
              containerClass="carousel-container position-initial"
              renderArrowsOutside
              renderButtonGroupOutside
            >
              {clients.map((client, index) => {
                const imageSrc = client.img
                  ? `${FILE_URL}${client.img}`
                  : "https://placehold.co/90x90/3f51b5/ffffff?text=N/A";

                return (
                  <div
                    key={index}
                    className={`client-box ${
                      index % 2 === 0 ? "pr-2 pl-0" : "pl-2 pr-0"
                    } sm:px-0 px-1`}
                  >
                  <div className="client-header">
    <img
      src={imageSrc}
      alt={client.name}
      className="client-photo"
    />

    <div className="client-info">
      <p className="client-name">{client.name}</p>
      <p className="client-position">{client.postOfPerson}</p>
    </div>
  </div>

                    <p className="client-feedback">{client.description}</p>
                  </div>
                );
              })}
            </Carousel>
          )}
        </div>
       <style jsx>{`
  .react-multiple-carousel__arrow--left:hover::before,
  .react-multiple-carousel__arrow--right:hover::before {
    color: #b556cfff !important;
  }

  .react-multiple-carousel__arrow--left::before,
  .react-multiple-carousel__arrow--right::before {
    font-size: 30px;
    height: 45px;
  }

  .position-initial {
    position: initial !important;
  }

  .client-photo {
    border-radius: 50%;
    object-fit: cover;
  }

  /* ONLY ARROW OUTSIDE */

  .react-multiple-carousel__arrow--left {
    left: 5px !important;
  }

  .react-multiple-carousel__arrow--right {
    right: 5px !important;
  }
@media (max-width: 768px) {

  .client-box {
    width: 100% !important;
    padding: 0 !important;
  }

  .client-header {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 20px !important;
    flex-wrap: nowrap;
  }

  .client-photo {
    width: 90px !important;
    height: 90px !important;
    min-width: 90px;
  }

  .client-info {
    flex: 1;
  }

  .client-name {
    font-size: 16px !important;
    line-height: 1.3;
    margin-bottom: 8px;
    word-break: break-word;
  }

 .client-position {
  font-size: 13px !important;
  line-height: 1.5;
  word-break: break-word;
  text-align: left !important;
}

  .client-feedback {
    padding: 20px !important;
    font-size: 12px !important;
    line-height: 1.8 !important;
    word-break: break-word;
  }

  .react-multiple-carousel__arrow {
    display: none !important;
  }
}
`}</style>
      </section>
    );
  };

  export default HappyClients;
